var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "simple-form flex col-2" }, [
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.retailerComName))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.retailerBizUnitName))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.shopDeviceIoRecord.retailerComTagName || "无"))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.warehouseName))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(4),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.devcVoucherTypeMap[_vm.shopDeviceIoRecord.srcVoucherType]
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(5),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.srcVoucherNo))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(6),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.ioFlagMap[_vm.shopDeviceIoRecord.ioFlag]))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _c("div", { staticClass: "form-label" }, [
        _c("label", [
          _vm._v(
            _vm._s(
              _vm.shopDeviceIoRecord.lowCostFlag ? "耗材名称" : "资产描述全称"
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.title))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(7),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.batchNo || "无"))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(8),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.assetKindName || ""))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(9),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.svcNo || "无"))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(10),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.catName || "无"))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(11),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.getGoodsCatDevcGroupName(_vm.shopDeviceIoRecord.catId) || "无"
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(12),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.brandName))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(13),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.model || "无"))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(14),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.fixedSpec || "无"))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(15),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.quantity || 0))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(16),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.theUnit || ""))])
      ])
    ]),
    _vm._v(" "),
    !_vm.shopDeviceIoRecord.durable
      ? _c("div", { staticClass: "form-group center" }, [
          _vm._m(17),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.shopDeviceIoRecord.rented ? "是" : "否"))
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(18),
      _vm._v(" "),
      _c("div", { staticClass: "form-value" }, [
        _c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.createTime))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(19),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-value",
          staticStyle: { width: "-webkit-calc(100% - 126px - 20px)" }
        },
        [_c("span", [_vm._v(_vm._s(_vm.shopDeviceIoRecord.memo || "无"))])]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("业务单元")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("所属部门")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构标签")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("仓库名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("来源单据类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("来源单据号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("出入库")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("批次号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("财务类别")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("服务号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("分类")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("分类分组")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("品牌")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("型号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("规格")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("单位")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否租赁")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("备注")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47ee4fa4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47ee4fa4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopDeviceIoRecordDetail.vue
// module id = 3077
// module chunks = 0